
import React, { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import ManufacturerModal from './ManufacturerModal';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
const ManufacturerList = ({ history }) => {

    const manufacturerModalRef          =   useRef(null);
    const manufacturerUrl               =   BACKOFFICE_BASE_URL + '/manufacturer/list';
    const manufacturerDeleteUrl         =   BACKOFFICE_BASE_URL + '/manufacturer/delete';


    const access_token                  =   useSelector(state => state.auth.access_token);
    const permissions                   =   useSelector(state => state.app.acl_info?.permissions || []);
    const initManufacturerModal         =       ()  =>   {
        if (manufacturerModalRef.current) {
            manufacturerModalRef.current.initModalHandler();
        }
    };
    const [listingLoading, setListingLoading]                                    =    useState(false);
    const [manufacturerListing, setManufacturerListing]                          =    useState([]);
    const [listingMeta, setListingMeta]                                          =    useState(null);
    const [formSearchedElems, setFormSearchedElems]                              =    useState([]);
    const [submittedManufacturerFilterForm, setSubmittedManufacturerFilterForm]  =    useState({});


    useEffect(()        =>       {
        loadListingTblData(1);
    }, []);
    
    const loadListingTblData = (page = 1, searchParams = submittedManufacturerFilterForm) => {
        setListingLoading(true);

        const params = {
            page: page,
            per_page: 100
        };
        if (searchParams && Object.keys(searchParams).length > 0) {
            Object.keys(searchParams).forEach(key => {
                if (searchParams[key] && searchParams[key].toString().trim() !== '') {
                    params[key] = searchParams[key];
                }
            });
        }
        HttpAPICall.withAthorization('GET', manufacturerUrl, access_token, params, {}, (resp) => {
            const respData = resp.data;
            setManufacturerListing(respData.data);
            setListingMeta({
                from: respData.from,
                to: respData.to,
                total: respData.total,
                last_page: respData.last_page,
                per_page: respData.per_page,
                current_page: respData.current_page
            });
        }).then(() => setListingLoading(false));
    };
    const handleSearch = (params, searchedElems) => {
        setFormSearchedElems(searchedElems);
        setSubmittedManufacturerFilterForm(params);
        loadListingTblData(1, params);
    };

    const addManufacturerFormInit = () => {
        history.push('/add_manufacturer');
    };

    const editManufacturerInit = (item) => {
        history.push({ pathname: `/add_manufacturer`, state: { editManufacturerData: item } });
    };
    const manufacturerSearchClear = () => {
        setFormSearchedElems([]);
        setSubmittedManufacturerFilterForm({});
        if (manufacturerModalRef.current) {
            manufacturerModalRef.current.resetForm();
        }
        loadListingTblData(1, {});
    };

    const manufacturerJsx                 =  ()       =>   {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div>
                        <h3>Manufacturer List</h3>
                        <div className="text-end mt15">
                            <Ax>
                                {permissions.includes('asset_manufacturer_add') && (
                                    <button type="button" className="btn btn-primary" onClick={addManufacturerFormInit}>New</button>
                                )}
                                <button type="button" className="btn btn-secondary" onClick={initManufacturerModal} disabled={listingLoading}>
                                    <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </Ax>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{manufacturerListingJsx()}</div>
                    </div>
                </div>
            </Ax>
        );
    };

   const  deleteManufacturer = (id) => {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    HttpAPICall.withAthorization('DELETE', manufacturerDeleteUrl + '/' + id , access_token,{},{},(resp) => {
                        toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                        loadListingTblData(1)
                    });
                }
            });
    }

    
    const manufacturerListingJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria
                    searchedElems={formSearchedElems}
                    onClearFilter={manufacturerSearchClear}
                />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            <Ax>
                                <th scope="col" style={{ width: "5%" }}>S.No</th>
                                <th scope="col" style={{ width: "43%" }}>Name</th>
                                <th scope="col" style={{ width: "20%" }}>Nick Name</th>
                                <th scope="col" className="text-center" style={{ width: "25%" }}>Remarks</th>
                                <th scope="col" className="text-center" style={{ width: "7%" }}>Action</th>
                            </Ax>
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="5"><Loader /></td></tr>)
                            : (manufacturerListing && manufacturerListing.length > 0
                                ? (manufacturerListing.map((item, index) => (
                                    <tr key={index}>
                                        <Ax>
                                            <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                            <td>{item.manufacturer ? item.manufacturer : "-"}</td>
                                            <td>{item.mnf_nick_name ? item.mnf_nick_name : "-"}</td>
                                            <td>{item.description ? item.description : "-"}</td>
                                            <td className='text-center'>
                                                <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                <ul className="dropdown-menu">
                                                    {permissions.includes('asset_manufacturer_edit') && (
                                                        <li onClick={() => editManufacturerInit(item)}>
                                                            <a className="dropdown-item" role="button">Edit</a>
                                                        </li>)}
                                                    {permissions.includes('asset_manufacturer_delete') && (
                                                        <li onClick={() => deleteManufacturer(item.id)}>
                                                            <a className="dropdown-item" role="button">Delete</a>
                                                        </li>
                                                    )}
                                                </ul>
                                            </td>
                                        </Ax>
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1 ,submittedManufacturerFilterForm)}
                />
            </Ax>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Manufacturer Listing</title></Helmet>
            {manufacturerJsx()}
            <ManufacturerModal ref={manufacturerModalRef} onSearch={handleSearch}
                initialSearchForm={submittedManufacturerFilterForm} />
        </ApplicationLayout>
    );
};

export default ManufacturerList;
